module.exports = __webpack_public_path__ + "img/88.a4ac3366.png";